export const FETCH_END = "setArticles";
export const FETCH_START = "setLoading";
export const PURGE_AUTH = "logOut";
export const RESET_ERROR_MESSAGES = "resetErrorMessages";
export const SET_ASSET = "setAsset";
export const SET_ASSETS = "setAssets";
export const SET_AUTH = "setUser";
export const SET_CONFIG_ITEM = "setConfigItem";
export const SET_CONFIG_ITEMS = "setConfigItems";
export const SET_ERROR = "setError";
export const SET_LANGS = "setLanguages";
export const SET_MESSAGE = "setMessage";
export const SET_NAVIGATION = "setNavigation";
export const SET_PAGE = "setPage";
export const SET_PAGES = "setPages";
export const SET_USER = "setUser";
export const SET_USERLIST = "setUserlist";
export const SET_USERS = "setUsers";
export const RESET_STATE = "resetModuleState";
